import React, { useEffect, useState, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import Modal from "react-bootstrap/Modal";
import DataTable from "react-data-table-component";

//Components
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import SourcingCommonFilter from "../../../../Components/Filter/Sourcing/SourcingCommonFilter";
import { SearchField } from "../../../../Components/formElements/SearchField";
import { MessageCircle } from "lucide-react";
import ChatBox from "../../../../Components/ChatBox/ChatBox";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import ReverseTimer from "../../../../Components/TableReverseTimer/ReverseTimer";
import { formatDateTime } from "../../../../common/Validations";
import { useDispatch, useSelector } from "react-redux";
import {
  addauctionNr,
  getEauction,
} from "../../../../redux/feature/supplier_app/eauctionSlice";
import { useNavigate } from "react-router-dom";
// import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import toast from "react-hot-toast";
import ItemService from "../../../../services/supplier_appCommonService";
import AuctionTermsAcknowledgeModal from "../AuctionTermsAcknowledgeModal";
import socket from "../../../../utils/socket";

//  Main Component
const SupplierRevAuctionList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "eAuction");
  localStorage.setItem("submenu", "Reverse Auction");

  let customerData = useSelector((state) => state.eauctionSlice.eauction);
  let customerTable = useSelector(
    (state) => state.eauctionSlice.eauction.pagination,
  );
  // const currentUser = useSelector((state) => state.authSlice?.userData);
  const currentUser = useSelector((state) => state.login?.loginData);
  console.log("Full currentUser:", currentUser);

  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [getNewPerPage, setNewPerPage] = useState(10);

  // ── T&C Modal state ──────────────────────────────────────────────────────
  const [showTCModal, setShowTCModal] = useState(false);
  const [selectedAuction, setSelectedAuction] = useState(null);

  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const supplierId = userData?.data?.userId || userData?.data?.AssociateNumber;

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // Tracks the latest known closingDateTime per auction (from socket events),
  // so a stale poll response can never regress a row's displayed time
  const latestClosingTimesRef = useRef({});
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  useEffect(() => {
    // Filter to show only active auctions. Status (kept fresh by the backend's
    // periodic auto-close sweep) is the source of truth here -- NOT closingDateTime,
    // which can be briefly stale right after an extension until the next poll catches up.
    if (customerData?.data) {
      const activeAuctions = customerData.data.filter((auction) => {
        if (auction.deliveryStatusHeader === "Closed" || auction.auctionStatus === "Ended") {
          return false;
        }
        if (auction.deliveryStatusHeader == null && auction.auctionStatus == null && auction.closingDateTime) {
          return new Date(auction.closingDateTime) > new Date();
        }
        return true;
      }).map((auction) => {
        // If we've already learned a later closing time via socket for this auction
        // (e.g. an extension the poll hasn't picked up yet), keep the newer one, for display.
        const known = latestClosingTimesRef.current[auction.auctionNr || auction.documentNumber];
        if (known && (!auction.closingDateTime || new Date(known) > new Date(auction.closingDateTime))) {
          return { ...auction, closingDateTime: known };
        }
        return auction;
      });
      setData(activeAuctions);
    }
  }, [customerData]);

  // Real-time sync: listen for auto-extension / auto-close events so the
  // list updates immediately instead of waiting for the next poll
  useEffect(() => {
    if (!socket.connected) socket.connect();

    const handleExtended = (payload) => {
      if (!payload?.auctionId) return;
      if (payload.newClosingTime) {
        latestClosingTimesRef.current[payload.auctionId] = payload.newClosingTime;
      }
      setData((prev) =>
        prev.map((row) =>
          (row.auctionNr || row.documentNumber) === payload.auctionId
            ? {
                ...row,
                closingDateTime: payload.newClosingTime || row.closingDateTime,
              }
            : row
        )
      );
    };

    const handleEnded = (payload) => {
      if (!payload?.auctionId) return;
      delete latestClosingTimesRef.current[payload.auctionId];
      setData((prev) => prev.filter((row) => (row.auctionNr || row.documentNumber) !== payload.auctionId));
    };

    socket.on("auction:extended", handleExtended);
    socket.on("auction:ended", handleEnded);

    return () => {
      socket.off("auction:extended", handleExtended);
      socket.off("auction:ended", handleEnded);
    };
  }, []);

  // Join the socket room for every auction currently visible in the list
  useEffect(() => {
    data.forEach((row) => {
      const rowAuctionId = row?.auctionNr || row?.documentNumber;
      if (rowAuctionId) {
        socket.emit("auction:join", { auctionId: rowAuctionId, userRole: "supplier" });
      }
    });
  }, [data]);

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getReverseAuctionList",
      module: "",
      page: page,
      per_page: getNewPerPage,
    };
    dispatch(getEauction(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "getReverseAuctionList",
      module: "",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getEauction(obj));
  };

  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getReverseAuctionList",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getEauction(obj));
  };

  useEffect(() => {
    let obj = {
      queryName: "getReverseAuctionList",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getEauction(obj));

    // Refresh data every 30 seconds to sync timer updates
    const refreshInterval = setInterval(() => {
      dispatch(getEauction(obj));
    }, 30000);

    return () => clearInterval(refreshInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
 // eslint-disable-next-line
  const auctionDetail = (auctionNr) => {
    dispatch(addauctionNr(auctionNr?.documentNumber));
    navigate(Constants.EAUCTION_SUPPLIER_AUCTION_DETAILS);
  };

  const liveAuctionDetailPage = (auctionRow) => {
    console.log("firstQuote:", auctionRow?.firstQuote);
    console.log("firstQuoteBy:", auctionRow?.firstQuoteBy);
    console.log("items:", auctionRow?.items);
    dispatch(addauctionNr(auctionRow?.documentNumber));

    // Current logged-in supplier's AssociateNumber
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const currentSupplierCode =
      userData?.data?.AssociateNumber || userData?.data?.userId;

    // Find current supplier in supplierList and check acknowledged
    const supplierEntry = auctionRow?.supplierList?.find(
      (s) => String(s.AssociateNumber) === String(currentSupplierCode),
    );

    // console.log("supplierEntry:", supplierEntry);
    // console.log("acknowledged:", supplierEntry?.acknowledged);

    if (supplierEntry?.acknowledged === true) {
      navigate(Constants.EAUCTION_SUPPLIER_LIVE_AUCTION_DETAILS);
      return;
    }

    setSelectedAuction(auctionRow);
    setShowTCModal(true);
  };

  const handleAcknowledge = async () => {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const supplierId = userData?.data?.userId;

    try {
      const res = await ItemService.auctionAcknowledgeTerms({
        auctionId:
          selectedAuction?.documentNumber || selectedAuction?.auctionNr,
        supplierId: supplierId,
      });

      if (res?.status === 200) {
        setShowTCModal(false);
        setSelectedAuction(null);
        navigate(Constants.EAUCTION_SUPPLIER_LIVE_AUCTION_DETAILS);
      } else {
        toast.error(res?.message || "Acknowledge failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };
  // const isAuctionExpired = (closingDateTime) => {
  //   if (!closingDateTime) return true;
  //   const now = new Date();
  //   const closeTime = new Date(closingDateTime);
  //   return now >= closeTime;
  // };

  const isAuctionExpired = (row) => {
    if (row?.deliveryStatusHeader === "Closed" || row?.auctionStatus === "Ended") {
      return true;
    }
    if (!row?.closingDateTime) return true;
    const now = new Date();
    const closeTime = new Date(row.closingDateTime);
    return now >= closeTime;
  };
  const getLiveAuctionColumn = () => ({
    name: "Live Auction",
    cell: (row) => {
      const expired = isAuctionExpired(row);
      return (
        <button
          className="btn btnTable"
          onClick={() => liveAuctionDetailPage(row)}
          disabled={expired}
        >
          Live
        </button>
      );
    },
    selector: (row) => row.liveAuction1 || "--",
    sortable: true,
    width: "130px",
  });

  const [chatId, setChatId] = useState(null);
  const toggleChat = (groupId) => {
    if (chatId === groupId) {
      setChatId(null);
    } else {
      setChatId(groupId);
    }
  };

  const columns = [
    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span className="iconTable">
            <button
              onClick={() => toggleChat(row?.userId)}
              title={row?.userId ? "Chat With the User" : "No User Found"}
            >
              <MessageCircle className="w-5 h-5" />
            </button>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Auction Number",
      cell: (row) => {
        const expired = isAuctionExpired(row);
        return (
          <button
            className="btnInfo"
            onClick={() => liveAuctionDetailPage(row)}
            disabled={!expired}
          >
            {row.auctionNr || "-"}{" "}
          </button>
        );
      },
      selector: (row) => row.auctionNr,
      sortable: true,
      width: "150px",
    },
    {
      name: "RFQ Number",
      selector: (row) => row.rfqNr || "--",
      sortable: true,
      cell: (row) => <button className="btnInfo">{row.rfqNr || "-"} </button>,
      width: "150px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.auctionStatus} />
        </>
      ),
      width: "130px",
    },
    {
      name: "Auction Type",
      cell: (row) => (
        <TableStatusField status={row.auctionType} />
      ),
      selector: (row) => row.auctionType || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Start Time",
      selector: (row) => formatDateTime(row.openingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "End Time",
      selector: (row) => formatDateTime(row.closingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    // {
    //   name: "Remaining Time",
    //   cell: (row) => (
    //     <ReverseTimer
    //       openingDateTime={row.openingDateTime}
    //       closingDateTime={row.closingDateTime}
    //       isClosed={isAuctionExpired(row.closingDateTime)}
    //     />
    //   ),
    //   sortable: true,
    //   width: "270px",
    // },
    {
      name: "Remaining Time",
      cell: (row) => (
        <ReverseTimer
          key={row.closingDateTime}
          openingDateTime={row.openingDateTime}
          closingDateTime={row.closingDateTime}
          isClosed={isAuctionExpired(row)}
        />
      ),
      sortable: true,
      width: "270px",
    },
    getLiveAuctionColumn(),
    {
      name: "Comm",
      cell: (row) => <button className="btn btnTable">View</button>,
      selector: (row) => row.commType || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Order",
      cell: (row) => <button className="btn btnTable">View</button>,
      selector: (row) => row.order || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Auction Title",
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">{row?.auctionTitle}</span>
      ),
      selector: (row) => row.auctionTitle || "--",
      sortable: true,
      width: "130px",
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Supplier Auction List</h2>
                <p className="subText">
                  Lists of Supplier Auction List and details
                </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <hr />

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SL</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Supplier Auction List</span>
                      <span className="subHeaderTitle">
                        View of Supplier Auction List and Status
                      </span>
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[3, 4]}
                        leftOffsets={[0, 150]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          progressPending={customerData?.status}
                          paginationTotalRows={customerTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <AuctionTermsAcknowledgeModal
        show={showTCModal}
        onHide={() => {
          setShowTCModal(false);
          setSelectedAuction(null);
        }}
        onAcknowledge={handleAcknowledge}
        auctionNr={
          selectedAuction?.auctionNr || selectedAuction?.documentNumber
        }
        termsText={selectedAuction?.auctionDescription}
        documentId={selectedAuction?.eventDocument}
        firstQuote={selectedAuction?.firstQuote}
        firstQuoteBy={selectedAuction?.firstQuoteBy}
        items={selectedAuction?.items || []}
        itemQuantities={selectedAuction?.itemQuantities || {}}
        currency={selectedAuction?.auctionCurrencie?.[0]?.code || "INR"}
        fractions={selectedAuction?.fractions || 2}
        auctionId={selectedAuction?.documentNumber}
        supplierId={supplierId}
      />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
      />

      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
          handlePerRowsChange
        />
      )}
    </main>
  );
};

export default SupplierRevAuctionList;
